<template>
  <div class="app-container">
    <div class="tabs-bg">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="全部用户" name="all"></el-tab-pane>
        <el-tab-pane label="正常" name="active"></el-tab-pane>
        <el-tab-pane label="已禁用" name="inactive"></el-tab-pane>
        <el-tab-pane label="员工" name="staff"></el-tab-pane>
      </el-tabs>
    </div>

    <div class="summary-card">
      <div class="card-header">
        <div class="title-bar"></div>
        <span class="title">基础信息概览</span>
      </div>
      <div class="summary-content">
        <div class="stat-item">
          <div class="stat-value blue">{{ totalUsers }}</div>
          <div class="stat-label">用户总数</div>
        </div>
        <div class="stat-item">
          <div class="stat-value green">{{ activeUsers }}</div>
          <div class="stat-label">正常用户</div>
        </div>
        <div class="stat-item">
          <div class="stat-value red">{{ inactiveUsers }}</div>
          <div class="stat-label">禁用用户</div>
        </div>
      </div>
    </div>

    <div class="search-card">
      <el-form :inline="true" :model="searchParams" class="demo-form-inline" size="small">
        <el-form-item label="编号">
          <el-input v-model="searchParams.user_id" placeholder="编号" clearable style="width: 100px;"
            @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input v-model="searchParams.phone" placeholder="手机" clearable style="width: 100px;"
            @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="设备">
          <el-input v-model="searchParams.device_code" placeholder="设备" clearable style="width: 100px;"
            @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.province_code" placeholder="省" clearable style="width: 90px;"
            @change="onProvinceSelect">
            <el-option v-for="p in provinces" :key="p.code || p.id" :label="p.name" :value="p.code || p.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.city_code" placeholder="市" clearable style="width: 90px;"
            @change="onCitySelect">
            <el-option v-for="c in cities" :key="c.code || c.id" :label="c.name" :value="c.code || c.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.area_code" placeholder="区" clearable style="width: 90px;"
            @change="onAreaSelect">
            <el-option v-for="a in areas" :key="a.code || a.id" :label="a.name" :value="a.code || a.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.street_code" placeholder="街道" clearable style="width: 90px;"
            @change="onStreetSelect">
            <el-option v-for="s in streets" :key="s.code || s.id" :label="s.name" :value="s.code || s.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.community_code" placeholder="小区" clearable style="width: 110px;">
            <el-option v-for="cm in communities" :key="cm.code || cm.id" :label="cm.name" :value="cm.code || cm.id" />
          </el-select>
        </el-form-item>
        <el-form-item class="action-buttons">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch" class="search-btn">搜索</el-button>
          <el-button icon="el-icon-refresh-right" @click="handleReset">重置</el-button>
          <el-button icon="el-icon-download" class="export-btn" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-card">
    <el-table v-loading="loading" :data="usersData" fit highlight-current-row style="width: 100%" :header-cell-style="{background:'#f5f7fa',color:'#606266'}" size="small">
      <!-- <el-table-column prop="id" label="用户ID" width="80" align="center" /> -->
      <el-table-column prop="phone" label="手机号" width="140" align="center" />
      <!-- <el-table-column prop="real_name" label="姓名" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.real_name || '未设置' }}
        </template>
      </el-table-column> -->
      <el-table-column prop="balance" label="账户余额" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.balance.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="balance" label="累计金额" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_recycle_amount.toFixed(2) }}
        </template>
      </el-table-column>
        <el-table-column label="注册设备" width="180" align="center">
        <template slot-scope="scope">
          <span style="cursor: pointer; color: #409EFF;" @click="linkSearchByDeviceCode(scope.row)">
            {{ getPrimaryDeviceCode(scope.row) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="注册小区" width="180" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row && scope.row.community_txt" style="cursor: pointer; color: #409EFF;" @click="linkSearchByCommunity(scope.row)">
            {{ scope.row.community_txt }}
          </span>
          <span v-else>未关联小区</span>
        </template>
      </el-table-column>
      <el-table-column label="所属行政区" width="260" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row && (scope.row.province_txt || scope.row.city_txt || scope.row.area_txt || scope.row.street_txt)">
            <span v-if="scope.row.province_txt" style="cursor: pointer; color: #409EFF;" @click="linkSearchByProvince(scope.row)">{{ scope.row.province_txt }}</span>
            <span v-else>-</span>
            -
            <span v-if="scope.row.city_txt" style="cursor: pointer; color: #409EFF;" @click="linkSearchByCity(scope.row)">{{ scope.row.city_txt }}</span>
            <span v-else>-</span>
            -
            <span v-if="scope.row.area_txt" style="cursor: pointer; color: #409EFF;" @click="linkSearchByArea(scope.row)">{{ scope.row.area_txt }}</span>
            <span v-else>-</span>
            -
            <span v-if="scope.row.street_txt" style="cursor: pointer; color: #409EFF;" @click="linkSearchByStreet(scope.row)">{{ scope.row.street_txt }}</span>
            <span v-else>-</span>
          </span>
          <span v-else>未关联行政区</span>
        </template>
      </el-table-column>
      <el-table-column label="投递数据" width="180" align="center">
        <template slot-scope="scope">
          <div style="cursor: pointer; color: #409EFF;" @click="openUserDeliveryLogs(scope.row)">投递次数: {{ scope.row.total_deliveries || 0 }}</div>
          <div style="cursor: pointer; color: #409EFF;" @click="openUserDevices(scope.row)">使用过的设备: {{ scope.row.unique_device_count || 0 }}</div>
          <div>总重量: {{ scope.row.total_delivery_weight || 0 }}kg</div>
          <div>违规重量: {{ scope.row.violation_weight || 0 }}kg</div>
        </template>
      </el-table-column>
      <el-table-column prop="register_time" label="注册时间" width="160" align="center" />
      <el-table-column prop="last_delivery_time" label="最后投递时间" width="160" align="center" />
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" effect="plain">
            {{ scope.row.status === 1 ? '正常' : '已禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" v-permission="'user:view'" @click="handleView(scope.row)">
            查看
          </el-button>
          <el-button type="text" size="small" @click="openBalanceLogs(scope.row)">
            资金记录
          </el-button>
          <el-button v-if="scope.row.status === 1" type="text" size="small" style="color: #f56c6c;"
            @click="handleUpdateStatus(scope.row, 2)">
            禁用
          </el-button>
          <el-button v-if="scope.row.status === 2" type="text" size="small" @click="handleUpdateStatus(scope.row, 1)">
            启用
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrapper">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
        :page-sizes="[10, 20, 50, 100]" :page-size="searchParams.page_size" :current-page="searchParams.page"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
    </div>

    <el-dialog title="用户详情" :visible.sync="dialogVisible" width="700px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="用户ID">{{ currentUser.id }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ currentUser.phone }}</el-descriptions-item>
        <el-descriptions-item label="姓名">{{ currentUser.real_name || '未设置' }}</el-descriptions-item>
        <el-descriptions-item label="账户余额">{{ currentUser.balance ? currentUser.balance.toFixed(2) : '0.00'
          }}</el-descriptions-item>
        <el-descriptions-item label="注册时间">{{ currentUser.register_time }}</el-descriptions-item>
        <el-descriptions-item label="最后登录">{{ currentUser.last_login_time }}</el-descriptions-item>
        <el-descriptions-item label="角色" :span="2">
          <el-tag v-for="(role, index) in currentUser.roles" :key="index" size="mini" style="margin-right: 5px;">
            {{ getRoleName(role) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="投递次数">{{ currentUser.delivery_count || 0 }}</el-descriptions-item>
        <el-descriptions-item label="总投递重量">{{ currentUser.total_delivery_weight || 0 }}kg</el-descriptions-item>
        <el-descriptions-item label="违规重量">{{ currentUser.violation_weight || 0 }}kg</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="currentUser.status === 1 ? 'success' : 'danger'">
            {{ currentUser.status === 1 ? '正常' : '已禁用' }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>

      <div v-if="currentUser.company_info" style="margin-top: 20px;">
        <h4>公司信息</h4>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="公司ID">{{ currentUser.company_info.id }}</el-descriptions-item>
          <el-descriptions-item label="公司名称">{{ currentUser.company_info.name }}</el-descriptions-item>
          <el-descriptions-item label="地址" :span="2">{{ currentUser.company_info.address }}</el-descriptions-item>
          <el-descriptions-item label="负责人">{{ currentUser.company_info.manager_name }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ currentUser.company_info.manager_phone }}</el-descriptions-item>
          <el-descriptions-item label="客服电话">{{ currentUser.company_info.customer_service_phone
            }}</el-descriptions-item>
          <el-descriptions-item label="回收单价">{{ currentUser.company_info.recycle_bin_unit_price
            }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

    <el-dialog title="用户资金记录" :visible.sync="balanceDialogVisible" width="900px">
      <div style="margin-bottom: 10px;">用户ID：{{ balanceUserId }}</div>
      <el-table :data="balanceLogs" v-loading="balanceLoading" style="width: 100%">
        <el-table-column type="index" width="60" />
        <el-table-column prop="id" label="记录ID" width="90" />
        <el-table-column prop="change_type" label="变更类型" width="150" />
        <el-table-column prop="amount" label="变更金额" width="120">
          <template slot-scope="{ row }">{{ formatAmount(row.amount) }}</template>
        </el-table-column>
        <el-table-column prop="balance" label="余额" width="120">
          <template slot-scope="{ row }">{{ formatAmount(row.balance) }}</template>
        </el-table-column>
        <el-table-column prop="description" label="描述" />
        <el-table-column prop="created_at" label="时间" width="170" />
      </el-table>
      <div class="pagination" style="margin-top: 16px;">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="balanceTotal"
          :page-sizes="[10, 20, 50, 100]" :current-page="balanceParams.page" :page-size="balanceParams.page_size"
          @size-change="handleBalanceSizeChange" @current-change="handleBalanceCurrentChange" />
      </div>
    </el-dialog>
    <el-dialog title="用户投递列表" :visible.sync="userDeliveryLogsDialogVisible" width="900px">
      <div style="margin-bottom: 10px;">用户ID：{{ userDeliveryUserId }}</div>
      <el-table :data="userDeliveryLogs" v-loading="userDeliveryLogsLoading" style="width: 100%">
        <el-table-column type="index" width="60" />
        <el-table-column prop="id" label="记录ID" width="90" />
        <el-table-column prop="device_code" label="设备编号" width="150" />
        <el-table-column prop="delivery_weight" label="重量(kg)" width="120" />
        <el-table-column prop="submit_time" label="时间" width="170" />
        <el-table-column prop="status_text" label="状态" />
      </el-table>
      <div style="margin-top: 16px;">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="userDeliveryLogsTotal"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="userDeliveryLogsParams.page"
          :page-size="userDeliveryLogsParams.page_size"
          @size-change="handleUserDeliverySizeChange"
          @current-change="handleUserDeliveryCurrentChange"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="userDeliveryLogsDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="投递过的设备" :visible.sync="userDevicesDialogVisible" width="700px">
      <div style="margin-bottom: 10px;">用户ID：{{ userDeliveryUserId }}</div>
      <div>
        <el-tag v-for="(dev, idx) in userDevices" :key="idx" style="margin-right: 8px; margin-bottom: 8px;" effect="plain">{{ dev }}</el-tag>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="userDevicesDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList, deleteUser, updateUserStatus } from '@/api/users'
import { getDeliveries } from '@/api/deliveries'
import { getUserBalanceLogs } from '@/api/finances'
import request from '@/api/interceptor'

export default {
  name: 'UsersList',
  data() {
    return {
      loading: false,
      activeTab: 'all',
      searchParams: {
        user_id: '',
        phone: '',
        device_code: '',
        province_code: '',
        city_code: '',
        area_code: '',
        street_code: '',
        community_code: '',
        community_txt: '',
        province_txt: '',
        city_txt: '',
        area_txt: '',
        street_txt: '',
        page: 1,
        page_size: 10
      },
      usersData: [],
      total: 0,
      totalUsers: 0,
      activeUsers: 0,
      inactiveUsers: 0,
      dialogVisible: false,
      currentUser: {},
      balanceDialogVisible: false,
      balanceLoading: false,
      balanceUserId: null,
      balanceParams: { page: 1, page_size: 20 },
      balanceLogs: [],
      balanceTotal: 0,
      userDeliveryLogsDialogVisible: false,
      userDeliveryLogsLoading: false,
      userDeliveryLogsParams: { page: 1, page_size: 10 },
      userDeliveryLogsTotal: 0,
      userDeliveryUserId: null,
      userDeliveryLogs: [],
      userDevicesDialogVisible: false,
      userDevicesLoading: false,
      userDevices: [],
      provinces: [],
      cities: [],
      areas: [],
      streets: [],
      communities: []
    }
  },
  created() {
    const q = this.$route && this.$route.query ? this.$route.query : {}
    if (q.tab) {
      this.activeTab = String(q.tab)
    }
    this.fetchUserList()
    this.fetchProvinces()
  },
  methods: {
    handleTabClick() {
      this.searchParams.page = 1
      this.fetchUserList()
    },
    // 获取用户列表
    async fetchUserList() {
      this.loading = true
      try {
        const params = { page: this.searchParams.page, page_size: this.searchParams.page_size }
        if (this.activeTab === 'all') {
          params.status = 0
        } else if (this.activeTab === 'active') {
          params.status = 1
        } else if (this.activeTab === 'inactive') {
          params.status = 2
        }
        if (this.searchParams.user_id) {
          params.user_id = this.searchParams.user_id
        }
        if (this.searchParams.phone) {
          params.phone = this.searchParams.phone
        }
        if (this.searchParams.device_code) {
          params.device_code = this.searchParams.device_code
        }
        if (this.searchParams.province_code) {
          params.province_code = this.searchParams.province_code
        }
        if (this.searchParams.city_code) {
          params.city_code = this.searchParams.city_code
        }
        if (this.searchParams.area_code) {
          params.area_code = this.searchParams.area_code
        }
        if (this.searchParams.street_code) {
          params.street_code = this.searchParams.street_code
        }
        if (this.searchParams.community_code) {
          params.community_code = this.searchParams.community_code
        }
        if (this.searchParams.community_txt) {
          params.community_txt = this.searchParams.community_txt
        }
        if (this.searchParams.province_txt) {
          params.province_txt = this.searchParams.province_txt
        }
        if (this.searchParams.city_txt) {
          params.city_txt = this.searchParams.city_txt
        }
        if (this.searchParams.area_txt) {
          params.area_txt = this.searchParams.area_txt
        }
        if (this.searchParams.street_txt) {
          params.street_txt = this.searchParams.street_txt
        }
        if (this.activeTab === 'staff') {
          params.role = 1
          params.status = 0
        }

        const response = await getUserList(params)
        if (response && response.code === 0) {
          const data = response.data || {}
          const users = Array.isArray(data.users) ? data.users : []
          this.usersData = users
          this.total = Number(data.total) || users.length
          const allTotal = Number(data.all_total)
          const normalCount = Number(data.normal)
          const disabledCount = Number(data.disabled)
          this.totalUsers = Number.isFinite(allTotal) ? allTotal : (Number(data.total) || users.length)
          this.activeUsers = Number.isFinite(normalCount) ? normalCount : users.filter(u => u.status === 1).length
          this.inactiveUsers = Number.isFinite(disabledCount) ? disabledCount : users.filter(u => u.status === 2).length
        } else {
          this.$message.error('获取用户列表失败')
        }
      } catch (error) {
        console.error('获取用户列表出错:', error)
        this.$message.error('获取用户列表失败')
      } finally {
        this.loading = false
      }
    },

    handleUpdateStatus(row, newStatus) {
      const actionText = newStatus === 2 ? '禁用' : '启用'
      this.$confirm(`确定要${actionText}用户 ${row.phone} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await updateUserStatus({ user_id: row.id, status: newStatus })
          if (res && res.code === 0) {
            this.$message.success(`${actionText}成功`)
          } else {
            this.$message.error(`${actionText}失败`)
            return
          }
          this.fetchUserList()
        } catch (error) {
          this.$message.error(`${actionText}失败`)
        }
      }).catch(() => {
        this.$message.info(`已取消${actionText}`)
      })
    },

    // 搜索
    handleSearch() {
      this.searchParams.page = 1
      this.fetchUserList()
    },

    // 改变每页显示数量
    handleSizeChange(size) {
      this.searchParams.page_size = size
      this.fetchUserList()
    },

    // 改变页码
    handleCurrentChange(page) {
      this.searchParams.page = page
      this.fetchUserList()
    },

    // 重置
    handleReset() {
      this.searchParams = {
        user_id: '',
        phone: '',
        device_code: '',
        province_code: '',
        city_code: '',
        area_code: '',
        street_code: '',
        community_code: '',
        community_txt: '',
        province_txt: '',
        city_txt: '',
        area_txt: '',
        street_txt: '',
        page: 1,
        page_size: 10
      }
      this.cities = []
      this.areas = []
      this.streets = []
      this.communities = []
      this.fetchUserList()
    },

    // 导出
    async handleExport() {
      if (this.loading) {
        this.$message.warning('正在加载数据，请稍候再试')
        return
      }
      
      const confirmText = `确定要导出当前筛选条件下的所有用户数据吗？(共 ${this.total} 条)`
      try {
        await this.$confirm(confirmText, '提示', {
          confirmButtonText: '确定导出',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '正在准备导出数据，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        // 构建基础参数
        const baseParams = { page_size: 100 } // 分批每次获取100条
        if (this.activeTab === 'all') baseParams.status = 0
        else if (this.activeTab === 'active') baseParams.status = 1
        else if (this.activeTab === 'inactive') baseParams.status = 2
        else if (this.activeTab === 'staff') {
          baseParams.role = 1
          baseParams.status = 0
        }

        // 添加搜索条件
        const searchKeys = [
          'user_id', 'phone', 'device_code', 'province_code', 'city_code',
          'area_code', 'street_code', 'community_code', 'community_txt',
          'province_txt', 'city_txt', 'area_txt', 'street_txt'
        ]
        searchKeys.forEach(key => {
          if (this.searchParams[key]) baseParams[key] = this.searchParams[key]
        })

        const allData = []
        const totalPages = Math.ceil(this.total / baseParams.page_size)

        // 分批获取数据
        for (let page = 1; page <= totalPages; page++) {
          loading.text = `正在导出数据... (${page}/${totalPages})`
          const res = await getUserList({ ...baseParams, page })
          if (res && res.code === 0 && res.data && Array.isArray(res.data.users)) {
            allData.push(...res.data.users)
          } else {
            throw new Error(`第 ${page} 页数据获取失败`)
          }
        }

        // 转换数据格式
        const exportData = allData.map(user => {
          // 格式化行政区
          let region = '未关联行政区'
          if (user.province_txt || user.city_txt || user.area_txt || user.street_txt) {
            region = [
              user.province_txt || '-',
              user.city_txt || '-',
              user.area_txt || '-',
              user.street_txt || '-'
            ].join('/')
          }

          return {
            '用户编号': user.id,
            '手机号': user.phone,
            '账户余额': user.balance ? user.balance.toFixed(2) : '0.00',
            '累计金额': user.total_recycle_amount ? user.total_recycle_amount.toFixed(2) : '0.00',
            '注册设备': this.getPrimaryDeviceCode(user),
            '注册小区': user.community_txt || '未关联小区',
            '所属行政区': region,
            '投递次数': (user.total_deliveries || 0) + '次',
            '使用过的设备': (user.unique_device_count || 0) + '台',
            '总投递重量': (user.total_delivery_weight || 0) + 'kg',
            '违投重量': (user.violation_weight || 0) + 'kg',
            '注册时间': user.register_time,
            '最后投递时间': user.last_delivery_time,
            '状态': user.status === 1 ? '正常' : '已禁用'
          }
        })

        // 导出Excel
        import('xlsx').then(XLSX => {
          const ws = XLSX.utils.json_to_sheet(exportData)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, ws, '用户列表')
          XLSX.writeFile(wb, `用户列表_${new Date().toLocaleDateString()}.xlsx`)
          this.$message.success('导出成功')
        })

      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败: ' + (error.message || '未知错误'))
      } finally {
        loading.close()
      }
    },

    // 查看用户详情
    async handleView(row) {
      this.currentUser = { ...row }
      this.dialogVisible = true
    },
    async openBalanceLogs(row) {
      this.balanceUserId = row.id || row.user_id
      this.balanceParams.page = 1
      this.balanceDialogVisible = true
      await this.fetchBalanceLogs()
    },
    getPrimaryDeviceCode(row) {
      const list = Array.isArray(row && row.device_box_list) ? row.device_box_list : []
      const first = list.length > 0 ? list[0] : null
      const code = (first && (first.device_code || first.code)) || ''
      return code || 'SN00000000001'
    },
    linkSearchByDeviceCode(row) {
      const code = this.getPrimaryDeviceCode(row)
      this.searchParams.device_code = code
      this.searchParams.page = 1
      this.fetchUserList()
    },
    async fetchProvinces() {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get' })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.provinces = list
      } catch (e) {
        this.provinces = []
      }
    },
    async fetchCities(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.cities = list
      } catch (e) {
        this.cities = []
      }
    },
    async fetchAreas(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.areas = list
      } catch (e) {
        this.areas = []
      }
    },
    async fetchStreets(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.streets = list
      } catch (e) {
        this.streets = []
      }
    },
    async fetchCommunities(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.communities = list
      } catch (e) {
        this.communities = []
      }
    },
    onProvinceSelect(code) {
      this.searchParams.city_code = ''
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.cities = []
      this.areas = []
      this.streets = []
      this.communities = []
      if (code) this.fetchCities(code)
    },
    onCitySelect(code) {
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.areas = []
      this.streets = []
      this.communities = []
      if (code) this.fetchAreas(code)
    },
    onAreaSelect(code) {
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.streets = []
      this.communities = []
      if (code) this.fetchStreets(code)
    },
    onStreetSelect(code) {
      this.searchParams.community_code = ''
      this.communities = []
      if (code) this.fetchCommunities(code)
    },
    linkSearchByCommunity(row) {
      const province_code = row && (row.province_code || row.province_id)
      const city_code = row && (row.city_code || row.city_id)
      const area_code = row && (row.area_code || row.area_id)
      const street_code = row && (row.street_code || row.street_id)
      const community_code = row && (row.community_code || row.community_id)
      this.searchParams.province_code = province_code || ''
      this.searchParams.city_code = city_code || ''
      this.searchParams.area_code = area_code || ''
      this.searchParams.street_code = street_code || ''
      this.searchParams.community_code = community_code || ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.searchParams.page = 1
      this.fetchUserList()
    },
    linkSearchByProvince(row) {
      const province_code = row && (row.province_code || row.province_id)
      this.searchParams.province_code = province_code || ''
      this.searchParams.city_code = ''
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.searchParams.page = 1
      this.fetchUserList()
    },
    linkSearchByCity(row) {
      const province_code = row && (row.province_code || row.province_id)
      const city_code = row && (row.city_code || row.city_id)
      this.searchParams.province_code = province_code || ''
      this.searchParams.city_code = city_code || ''
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.searchParams.page = 1
      this.fetchUserList()
    },
    linkSearchByArea(row) {
      const province_code = row && (row.province_code || row.province_id)
      const city_code = row && (row.city_code || row.city_id)
      const area_code = row && (row.area_code || row.area_id)
      this.searchParams.province_code = province_code || ''
      this.searchParams.city_code = city_code || ''
      this.searchParams.area_code = area_code || ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.searchParams.page = 1
      this.fetchUserList()
    },
    linkSearchByStreet(row) {
      const province_code = row && (row.province_code || row.province_id)
      const city_code = row && (row.city_code || row.city_id)
      const area_code = row && (row.area_code || row.area_id)
      const street_code = row && (row.street_code || row.street_id)
      this.searchParams.province_code = province_code || ''
      this.searchParams.city_code = city_code || ''
      this.searchParams.area_code = area_code || ''
      this.searchParams.street_code = street_code || ''
      this.searchParams.community_code = ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.searchParams.page = 1
      this.fetchUserList()
    },
    async openUserDeliveryLogs(row) {
      this.userDeliveryUserId = row.id || row.user_id
      this.userDeliveryLogsDialogVisible = true
      this.userDeliveryLogsParams.page = 1
      await this.fetchUserDeliveryLogs()
    },
    async fetchUserDeliveryLogs() {
      this.userDeliveryLogsLoading = true
      try {
        const p = this.userDeliveryLogsParams.page
        const ps = this.userDeliveryLogsParams.page_size
        const res = await getDeliveries({ page: p, page_size: ps, user_id: this.userDeliveryUserId })
        const ok = res && res.code === 0 && res.data
        const logs = ok && Array.isArray(res.data.delivery_logs) ? res.data.delivery_logs : []
        const total = ok ? Number(res.data.total) || logs.length : 0
        this.userDeliveryLogs = logs
        this.userDeliveryLogsTotal = total
      } catch (e) {
        this.userDeliveryLogs = []
        this.userDeliveryLogsTotal = 0
      } finally {
        this.userDeliveryLogsLoading = false
      }
    },
    handleUserDeliverySizeChange(size) {
      this.userDeliveryLogsParams.page_size = size
      this.userDeliveryLogsParams.page = 1
      this.fetchUserDeliveryLogs()
    },
    handleUserDeliveryCurrentChange(page) {
      this.userDeliveryLogsParams.page = page
      this.fetchUserDeliveryLogs()
    },
    async openUserDevices(row) {
      this.userDeliveryUserId = row.id || row.user_id
      this.userDevicesDialogVisible = true
      await this.fetchUserDevices()
    },
    async fetchUserDevices() {
      this.userDevicesLoading = true
      try {
        const page_size = 100
        const first = await getDeliveries({ page: 1, page_size, user_id: this.userDeliveryUserId })
        const ok = first && first.code === 0 && first.data
        const logs1 = ok && Array.isArray(first.data.delivery_logs) ? first.data.delivery_logs : []
        const total = ok ? Number(first.data.total) || logs1.length : 0
        const pages = Math.max(1, Math.ceil(total / page_size))
        const all = [...logs1]
        for (let p = 2; p <= pages; p++) {
          const res = await getDeliveries({ page: p, page_size, user_id: this.userDeliveryUserId })
          const more = (res && res.code === 0 && res.data && Array.isArray(res.data.delivery_logs)) ? res.data.delivery_logs : []
          all.push(...more)
        }
        const devSet = new Set((all || []).map(i => i.device_code).filter(Boolean))
        this.userDevices = Array.from(devSet)
      } catch (e) {
        this.userDevices = []
      } finally {
        this.userDevicesLoading = false
      }
    },
    async fetchBalanceLogs() {
      this.balanceLoading = true
      try {
        const params = { user_id: this.balanceUserId, page: this.balanceParams.page, page_size: this.balanceParams.page_size }
        const res = await getUserBalanceLogs(params)
        const data = (res && res.data) || {}
        const logs = Array.isArray(data.logs) ? data.logs : []
        const total = data.total != null ? data.total : 0
        const page = data.page != null ? data.page : this.balanceParams.page
        const page_size = data.page_size != null ? data.page_size : this.balanceParams.page_size
        this.balanceLogs = logs
        this.balanceTotal = Number(total) || 0
        this.balanceParams.page = Number(page) || this.balanceParams.page
        this.balanceParams.page_size = Number(page_size) || this.balanceParams.page_size
      } catch (e) {
        this.balanceLogs = []
        this.balanceTotal = 0
      } finally {
        this.balanceLoading = false
      }
    },
    handleBalanceSizeChange(size) {
      this.balanceParams.page_size = size
      this.fetchBalanceLogs()
    },
    handleBalanceCurrentChange(page) {
      this.balanceParams.page = page
      this.fetchBalanceLogs()
    },

    // 编辑用户
    handleEdit(row) {
      this.$message(`编辑用户: ${row.phone}`)
      // 实际项目中可以跳转到编辑页面
      // this.$router.push(`/users/edit/${row.id}`)
    },

    // 删除用户
    handleDelete(row) {
      this.$confirm(`确定要删除用户 ${row.phone} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteUser(row.id)
          this.$message.success('删除成功')
          this.fetchUserList()
        } catch (error) {
          this.$message.error('删除失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 添加用户
    handleAddUser() {
      this.$message.info('新增用户功能待实现')
    },

    // 获取角色名称
    getRoleName(role) {
      const roleMap = {
        'delivery_user': '投递用户',
        'cleaner': '清运人员',
        'unspecified': '未指定',
        'admin': '管理员',
        'maintenance': '维护人员',
        'super_admin': '超级管理员'
      }
      return roleMap[role] || role
    },
    formatAmount(val) {
      const num = Number(val)
      if (isNaN(num)) return val
      return num.toFixed(2)
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 10px;
  background-color: #f4f6f8;
  min-height: 100vh;
}

/* Tabs */
.tabs-bg {
  background: #fff;
  padding: 10px 20px 0;
  border-radius: 4px;
  margin-bottom: 10px;
}
::v-deep .el-tabs__nav-wrap::after {
  height: 0;
}
::v-deep .el-tabs__item.is-active {
  color: #28b652;
}
::v-deep .el-tabs__active-bar {
  background-color: #28b652;
}
::v-deep .el-tabs__item:hover {
  color: #28b652;
}
::v-deep .el-tabs__item {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

/* Summary Card */
.summary-card {
  background: #fff;
  padding: 12px 20px;
  border-radius: 4px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  margin-right: 40px;
  min-width: 140px;
}
.title-bar {
  width: 4px;
  height: 16px;
  background: #28b652;
  margin-right: 10px;
  border-radius: 2px;
}
.title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.summary-content {
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  padding-bottom: 0;
  flex-grow: 1;
}
.stat-value {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 2px;
}
.stat-label {
  font-size: 13px;
  color: #666;
}
.blue { color: #409EFF; }
.green { color: #28b652; }
.red { color: #F56C6C; }

/* Search Card */
.search-card {
  background: #fff;
  padding: 18px 5px 0;
  border-radius: 4px;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow-x: hidden;
}

::v-deep .el-form-item {
  margin-bottom: 18px;
  margin-right: 2px;
}
.export-btn {
  color: #28b652;
  border-color: #28b652;
  background: #fff;
}
.export-btn:hover {
  background: #f0f9eb;
  border-color: #28b652;
  color: #28b652;
}
.search-btn {
  background-color: #28b652;
  border-color: #28b652;
}
.search-btn:hover, .search-btn:focus {
  background-color: #38b63c;
  border-color: #38b63c;
}

/* Table Card */
.table-card {
  background: #fff;
  padding: 15px;
  border-radius: 4px;
}
.pagination-wrapper {
  text-align: center;
  margin-top: 15px;
}
</style>
